import React, { useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Formsy from "formsy-react";
import { useAsyncSetState } from "use-async-setstate";
import { useMutation } from "@apollo/client";
import {getOperationName} from "apollo-utilities";

import Modal from "../../bootstrap/modal";
import {removeDeviceUserMutation, removeUserDeviceMutation} from "../../logic/device";
import { getCurrentUserQuery } from "../../logic/user";

export default function ChangeDetails(props) {
  const [state, setState] = useAsyncSetState({
    processing: false,
    error: "",
  });

  const { onClose, device } = props;
  const formRef = useRef(null);
  const [removeDevice] = useMutation(removeUserDeviceMutation);
  const [removeDeviceUser] = useMutation(removeDeviceUserMutation);

  async function handleSubmit() {
    await setState((prevState) => ({ ...prevState, processing: true }));

    try {

      await removeDeviceUser({
        variables: {
          id: device.id,
        },
      })

      await removeDevice({
        variables: {
          deviceId: device.id,
        },
        awaitRefetchQueries: true,
        refetchQueries: [getOperationName(getCurrentUserQuery)],
      })

      await setState((prevState) => ({ ...prevState, processing: false }));
      return onClose();
    } catch (err) {
      return setState((prevState) => ({ ...prevState, processing: false, error: err }));
    }
  }

  return (
    <Modal
      title={"Remove Device"}
      show
      onClose={async() => onClose()}
      className="remove-device-modal"
      footer={
        <Container>
          <Row>
            <Col xs="auto ml-auto" className="pl-1 pr-1">
              <Button
                className="vw-button btn btn-white"
                type="button"
                disabled={state.processing}
                onClick={(e) => {
                  e.preventDefault();
                  return onClose();
                }}
              >
                {"Cancel"}
              </Button>
            </Col>
            <Col xs="auto" className="pl-1 pr-1">
              <Button
                className="vw-button btn btn-blue"
                type="submit"
                disabled={state.processing}
                onClick={() => formRef.current.submit()}
              >
                {"Delete"}
              </Button>
            </Col>
          </Row>
        </Container>
      }
    >
      <Formsy ref={formRef} onValidSubmit={handleSubmit}>
        {state.error && <Row>
          <Col>
            <div className="alert alert-danger">
              {state.error}
            </div>
          </Col>
        </Row>}
        <Row>
          <Col>
            <div className="text-center">
              {`Delete Device `}
              <span className="font-weight-bold">
                {`${device.hostname || device.macAddress}`}
              </span>
            </div>
          </Col>
        </Row>
      </Formsy>
    </Modal>
  );
}
